module.exports = require("npm:baguettebox.js@1.8.1/dist/baguetteBox.min.js");